import { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import dayjs from "dayjs";
import { DriverPeriodFilter } from "components/DriverPeriodFilter";
import { DriverCard, CardRow, DriverListSkeleton, EmptyState } from "components/DriverCard";
import { PageTitle } from "components/PageTitle";
import { driverDashboardService } from "services/driverDashboardService";
import { IDriverComplaints } from "interfaces/IDriverDashboard";
import { SummaryRow, SummaryValue, SummaryLabel } from "./styles";

const TODAY = dayjs().format("YYYY-MM-DD");

function SummarySkeleton() {
  return <Skeleton variant="text" width={48} sx={{ margin: "0 auto", fontSize: "1.4rem" }} />;
}

export function DriverComplaints() {
  const [startDate, setStartDate] = useState(TODAY);
  const [endDate, setEndDate] = useState(TODAY);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IDriverComplaints | null>(null);

  useEffect(() => {
    setLoading(true);
    driverDashboardService
      .getMyComplaints({ startDate, endDate })
      .then(setData)
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  return (
    <div aria-busy={loading}>
      <PageTitle>Quebras</PageTitle>

      <DriverPeriodFilter
        startDate={startDate}
        endDate={endDate}
        onChange={(start, end) => {
          setStartDate(start);
          setEndDate(end);
        }}
        disabled={loading}
      />

      <DriverCard>
        <SummaryRow>
          <div>
            <SummaryValue>{loading ? <SummarySkeleton /> : data?.totalComplaints ?? 0}</SummaryValue>
            <SummaryLabel>Quebras</SummaryLabel>
          </div>
          <div>
            <SummaryValue>{loading ? <SummarySkeleton /> : `${data?.complaintRate ?? 0}%`}</SummaryValue>
            <SummaryLabel>Taxa de quebra</SummaryLabel>
          </div>
          <div>
            <SummaryValue>{loading ? <SummarySkeleton /> : data?.totalOrders ?? 0}</SummaryValue>
            <SummaryLabel>Total de entregas</SummaryLabel>
          </div>
        </SummaryRow>
      </DriverCard>

      {loading ? (
        <DriverListSkeleton cards={3} rows={4} />
      ) : (
        <>
          {(data?.complaints?.length ?? 0) === 0 && (
            <EmptyState>Nenhuma quebra no período selecionado.</EmptyState>
          )}
          {data?.complaints?.map((complaint) => (
            <DriverCard key={`${complaint.complaintId}-${complaint.orderItemId}`} title={`Pedido ${complaint.orderId}`}>
              <CardRow>
                <span>Data</span>
                <strong>{dayjs(complaint.created).format("DD/MM/YYYY")}</strong>
              </CardRow>
              <CardRow>
                <span>Motivo</span>
                <strong>{complaint.reason}</strong>
              </CardRow>
              <CardRow>
                <span>Produto</span>
                <strong>{complaint.productName}</strong>
              </CardRow>
              {complaint.observation && (
                <CardRow>
                  <span>Observação</span>
                  <strong>{complaint.observation}</strong>
                </CardRow>
              )}
            </DriverCard>
          ))}
        </>
      )}
    </div>
  );
}

export default DriverComplaints;